var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploader-wrapper" }, [
    _vm.caption
      ? _c("span", { staticClass: "caption ft-xbld" }, [
          _vm._v(_vm._s(_vm.caption)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropzone",
        class: [_vm.hover ? "hover" : ""],
        on: {
          drop: function ($event) {
            $event.preventDefault()
            return _vm.onDrop.apply(null, arguments)
          },
          click: function ($event) {
            $event.preventDefault()
            return _vm.onClick.apply(null, arguments)
          },
          dragenter: function ($event) {
            $event.preventDefault()
            return _vm.onDragEnter.apply(null, arguments)
          },
          dragleave: function ($event) {
            $event.preventDefault()
            return _vm.onDragLeave.apply(null, arguments)
          },
        },
      },
      [
        _vm.previewSrc && this.type === "image"
          ? _c("div", {
              staticClass: "preview-container",
              style: { backgroundImage: "url(" + _vm.previewSrc + ")" },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.previewSrc && this.type === "video"
          ? _c("div", { staticClass: "preview-container" }, [
              _c("video", {
                attrs: {
                  src: _vm.previewSrc,
                  width: "100%",
                  autoplay: "",
                  muted: "",
                  loop: "",
                },
                domProps: { muted: true },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.previewSrc && !_vm.customClear
          ? _c(
              "div",
              {
                staticClass: "clear",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.onClear.apply(null, arguments)
                  },
                },
              },
              [_vm._v("+")]
            )
          : _vm.previewSrc && _vm.customClear
          ? _c(
              "span",
              {
                staticClass: "clear",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.onClear.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "19",
                      viewBox: "0 0 18 19",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13 2H16.5C17.3284 2 18 2.67157 18 3.5C18 4.32843 17.3284 5 16.5 5H16V16C16 17.6569 14.6569 19 13 19H5C3.34315 19 2 17.6569 2 16V5H1.5C0.671573 5 0 4.32843 0 3.5C0 2.67157 0.671573 2 1.5 2H5C5 0.895431 5.89543 0 7 0H11C12.1046 0 13 0.895431 13 2ZM5 14.5C5 15.3284 5.67157 16 6.5 16C7.32843 16 8 15.3284 8 14.5V8.5C8 7.67157 7.32843 7 6.5 7C5.67157 7 5 7.67157 5 8.5V14.5ZM11.5 16C10.6716 16 10 15.3284 10 14.5V8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V14.5C13 15.3284 12.3284 16 11.5 16Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _c("div", { staticClass: "placeholder" }, [
              _c("span", { staticClass: "ico" }),
              _vm._v(" "),
              _vm.customCaption
                ? _c("p", { staticClass: "txt ft-bld" }, [
                    _vm._v(_vm._s(_vm.customCaption)),
                  ])
                : _c("p", { staticClass: "txt ft-bld" }, [
                    _vm._v("Drag & drop a file or choose from your desktop"),
                  ]),
            ]),
      ]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" },
      ],
      ref: "inputFile",
      attrs: { type: "file" },
      on: { change: _vm.onInputFileChange },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }